import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

function toPascal(s) {
  if (!s) return null;
  return s.split(/[-_\s]+/).map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join('');
}

export function resolveIcon(name) {
  if (!name) return null;
  // Original D'Pots stored icons in two formats: 'home', 'trending-up', or 'DollarSign'.
  // Try exact match first, then PascalCase conversion.
  if (LucideIcons[name]) return LucideIcons[name];
  const pascal = toPascal(name);
  if (pascal && LucideIcons[pascal]) return LucideIcons[pascal];
  return null;
}

export function IconDisplay({ name, className = 'w-5 h-5', fallback = HelpCircle }) {
  const Icon = resolveIcon(name) || fallback;
  return <Icon className={className} />;
}

// Curated set of icons grouped by category (matches D'Pots original)
export const ICON_OPTIONS = [
  // Money & banking
  'DollarSign', 'CreditCard', 'Wallet', 'PiggyBank', 'Banknote', 'Coins', 'Receipt',
  'TrendingUp', 'TrendingDown', 'BarChart3', 'PieChart', 'Target', 'Award',
  // Home & life
  'Home', 'Building', 'Building2', 'Bed', 'Sofa', 'Lamp', 'Bath',
  // Transport
  'Car', 'Bus', 'Bike', 'Plane', 'Train', 'Ship', 'Fuel',
  // Food & shopping
  'ShoppingCart', 'ShoppingBag', 'Utensils', 'Coffee', 'Pizza', 'Apple', 'Wine',
  // Health & care
  'Heart', 'Stethoscope', 'Activity', 'Pill', 'Cross', 'Shield',
  // Education / work
  'Book', 'BookOpen', 'GraduationCap', 'Briefcase', 'Laptop', 'Code', 'Pen',
  // Family & social
  'User', 'Users', 'Baby', 'Gift', 'Smile', 'Gamepad', 'PartyPopper',
  // Nature / misc
  'Leaf', 'Sun', 'Cloud', 'Star', 'Flame', 'Sparkles', 'Wrench',
];
